(() => {
  'use strict';
  // Repair known import encoding damage in review text only.
  const fields = '.jdgm-rev__body, .jdgm-rev__title';
  const contractions = [
    ['I\uFFFD\uFFFDm', "I'm"], ['I\uFFFD\uFFFDve', "I've"],
    ['It\uFFFD\uFFFDs', "It's"], ['it\uFFFD\uFFFDs', "it's"],
    ['that\uFFFD\uFFFDs', "that's"], ['We\uFFFD\uFFFDve', "We've"],
    ['we\uFFFD\uFFFDve', "we've"], ['Men\uFFFD\uFFFDs', "Men's"],
    ['men\uFFFD\uFFFDs', "men's"], ['wearer\uFFFD\uFFFDs', "wearer's"],
    ['doesn\uFFFD\uFFFDt', "doesn't"]
  ];
  const repairText = value => {
    let text = value;
    contractions.forEach(([from, to]) => { text = text.split(from).join(to); });
    return text
      .replace(/360\uFFFD\uFFFD/g, '360°')
      .replace(/\uFFFDC(?=\s|$)/g, '–')
      .replace(/well\?constructed/g, 'well-constructed')
      .replace(/hassle\?free/g, 'hassle-free')
      .replace(/usb\?c/gi, match => match.replace('?', '-'))
      .replace(/\s*\uFFFD\?,Reviewed in the United States on [A-Za-z]+\s*\d{1,2}(?:,?\s*\d{4})?\s*$/g, '');
  };
  const repair = root => {
    const elements = root.matches?.(fields) ? [root] : [...root.querySelectorAll(fields)];
    elements.forEach(element => {
      if (element.matches('.jdgm-rev__title') && element.textContent.trim() === '10\uFFFD\uFFFD10\uFFFD\uFFFD') {
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
        element.style.setProperty('display', 'none', 'important');
        return;
      }
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const next = repairText(node.nodeValue);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
    });
  };
  const observed = new WeakSet();
  const attach = widget => {
    if (observed.has(widget)) return;
    observed.add(widget);
    repair(widget);
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; repair(widget); });
    });
    observer.observe(widget, { childList: true, subtree: true, characterData: true });
  };
  const start = () => {
    const main = document.getElementById('MainContent');
    if (!main) return;
    main.querySelectorAll('.jdgm-review-widget').forEach(attach);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches('.jdgm-review-widget')) attach(node);
        node.querySelectorAll('.jdgm-review-widget').forEach(attach);
      }));
    }).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
